export function tokensFromName(name) {
    return String(name || "")
      .toLowerCase()
      .replace(/['’]/g, "")
      .split(/[^a-z0-9]+/g)
      .filter(Boolean);
  }
  
  export function substringsFromTokens(tokens) {
    const out = new Set();
    for (const t of tokens || []) {
      const s = String(t || "");
      for (let i = 0; i < s.length; i++) {
        for (let j = i + 3; j <= s.length; j++) out.add(s.slice(i, j));
      }
    }
    return Array.from(out);
  }
  